/**
 * Global Axios interceptor — imported once at app entry.
 * Redirects to /login on any 401 response (expired/revoked token).
 */
import axios from 'axios';

let isRedirecting = false;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isRedirecting) {
      const path = window.location.pathname;
      // Don't redirect if already on a public/login/register page
      if (
        path === '/login' ||
        path === '/admin/login' ||
        path === '/provider/login' ||
        path === '/' ||
        path.startsWith('/sign-in') ||
        path.startsWith('/onboard') ||
        path.startsWith('/agent-onboard') ||
        path.startsWith('/provider-onboard') ||
        path.startsWith('/reset-password') ||
        path.startsWith('/search') ||
        path.startsWith('/connect') ||
        path.startsWith('/find-jobs') ||
        path.startsWith('/page/')
      ) {
        return Promise.reject(error);
      }

      isRedirecting = true;
      localStorage.removeItem('token');
      localStorage.removeItem('adminToken');
      localStorage.removeItem('providerToken');
      localStorage.removeItem('agent');
      window.location.replace('/login');
    }
    return Promise.reject(error);
  }
);
